import { observable } from 'mobx';

export type OrganizationBaseResponseArgs = {
  id: number;
  name: string;
  organization_id: number;
  address: string;
  postal_code: string;
  addressee: string;
  google_map_address?: string;
};

export type OrganizationBaseArgs = {
  id: number;
  name: string;
  organization_id: number;
  address: string;
  postal_code: string;
  addressee: string;
  google_map_address?: string;
};

export const convertOrganizationBaseResponseToArgs = (response: OrganizationBaseResponseArgs) => {
  const args: OrganizationBaseArgs = {
    id: response.id,
    name: response.name,
    organization_id: response.organization_id,
    address: response.address,
    postal_code: response.postal_code,
    addressee: response.addressee,
    google_map_address: response.google_map_address
  };
  return args;
};

export default class OrganizationBase {
  @observable id: number;
  @observable name: string;
  @observable organization_id: number;
  @observable address: string;
  @observable postal_code: string;
  @observable addressee: string;
  @observable google_map_address?: string;

  constructor(args: OrganizationBaseArgs) {
    this.id = args.id;
    this.name = args.name;
    this.organization_id = args.organization_id;
    this.address = args.address;
    this.postal_code = args.postal_code;
    this.addressee = args.addressee;
    this.google_map_address = args.google_map_address;
  }
}
